import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Helmet } from 'react-helmet';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import Loading from '../common/Loading';
import IntegrationGuide from '../common/IntegrationGuide';
import SponsorContainer from '../sponsorship/SponsorContainer';
import Analytics from '../common/Analytics';
import MPTokenInfo from './MPTokenInfo';

const GA_ACTION_NAME = "MPTokenPage";

class MPToken extends React.Component {
	constructor(props) {
		super(props);

		this.handleSelect = this.handleSelect.bind(this);
		const mpt_issuance_id = this.props.match.params.mpt_issuance_id;

		this.state = {
			key: 'mptokenholders',
            mpt_issuance_id: mpt_issuance_id,
            mpt: {},
			loading: false,
			error: null,
		}
	}

	// React view methods
	componentDidMount() {
		const { mpt_issuance_id } = this.state;
		this.fetchMPToken(mpt_issuance_id);
		Analytics.event({action: GA_ACTION_NAME, category: 'MPTokenInfo', label: mpt_issuance_id});
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.location.pathname !== nextProps.location.pathname) {
			const new_mpt_issuance_id = nextProps.match.params.mpt_issuance_id;
			this.setState({ mpt_issuance_id: new_mpt_issuance_id });
			this.fetchMPToken(new_mpt_issuance_id);
			Analytics.pageview();
		}
	}

	handleSelect(key) {
		switch (key) {
			case 'mptokenholders':
				break;
            default:
				break;
		}
		this.setState({key});
	}

	fetchMPToken(mpt_issuance_id) {
		this.setState({ loading: true })

		fetch(`${XRPSCAN_API_URL}/mpt/${mpt_issuance_id}`)
			.then(handleResponse)
			.then((data) => {
				this.setState({
					loading: false,
					mpt: data,
					error: null,
				});
			})
			.catch((error) => {
				this.setState({
					loading: false,
					error: error.errorMessage,
				});
			});
	}

	render() {
		const {
            mpt,
            mpt_issuance_id,
			loading,
		} = this.state;

		// render only loading component if loading state is set to true
		if (loading) {
			return <Loading />
		}

		return (
			<div>
				<Helmet>
					<title>{`${mpt?.Ticker || mpt_issuance_id}`} - XRPL MPToken Issuance | XRPSCAN</title>
				</Helmet>
				<Row>
					<Col>
						<IntegrationGuide/>
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={12}>
						<SponsorContainer />
					</Col>
				</Row>
				<Row>
					<Col xs={12} md={12}>
						<MPTokenInfo mpt={mpt} />
					</Col>
				</Row>
				{/* <Row>
					<Col xs={12} md={12}>
						<TextAd/>
					</Col>
				</Row> */}
				{/* <Row>
					<Col xs={12} md={12}>
						<Card>
							<Card.Body>
								<Card.Title>
									<XIcon icon='chart-line' />
									<span className="pl-2">MPToken Holders</span>
								</Card.Title>
								<Tabs
									activekey={this.state.key}
									defaultActiveKey={'mptokenholders'}
									onSelect={this.handleSelect}
									transition={false}
									mountOnEnter={true}
									unmountOnExit={true}
									id="mptoken-activity"
									className="mptoken-activity-tab"
								>
									<Tab eventKey="mptokenholders" title="Holders">
										<MPTokenHolder mpt_issuance_id={mpt_issuance_id}/>
									</Tab>
								</Tabs>
							</Card.Body>
						</Card>
					</Col>
				</Row> */}
			</div>
		)
	}
}
export default MPToken;